import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height={20.795}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 172537 139603"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#252422}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974604499264">
        <path
          d="M168493 92635c0 5757-4676 10438-10421 10438h-2329v-2755h3572c3542 0 6427-2878 6427-6420V13222c0-3542-2885-6422-6427-6422H13222c-3542 0-6427 2880-6427 6422v80676c0 3540 2885 6420 6427 6420h118581v2755h-28169v-5H68903v5H14458c-5737 0-10414-4681-10414-10438V14465c0-5744 4677-10421 10414-10421h143614c5745 0 10421 4677 10421 10421v78170zm-18477-8797h-12506c-3144 0-5707 2558-5707 5706v6729H13222c-1314 0-2383-1063-2383-2375V13222c0-1307 1069-2378 2383-2378h146093c1315 0 2383 1071 2383 2378v80676c0 1312-1068 2375-2383 2375h-3572v-6729c0-3148-2570-5706-5727-5706zm1680 16480v33558c0 929-754 1683-1680 1683h-12506c-914 0-1655-754-1655-1683V89544c0-921 739-1662 1655-1662h12506c926 0 1680 741 1680 1662v10774zm-78748 14775v-7975h26642v7975H72948zm40153 4044c2423-3 4392 1969 4392 4397v3580H55044v-3580c0-2428 1969-4397 4393-4397h53664zM158072 0H14458C6485 0 0 6493 0 14465v78170c0 7985 6485 14483 14458 14483h54445v7975h-9466c-4651 0-8437 3785-8437 8441v7625h70537v-7625c0-4656-3785-8441-8436-8441h-9467v-7975h28169v26758c0 3157 2563 5727 5707 5727h12506c3157 0 5724-2570 5724-5727l3-26758h2329c7980 0 14465-6498 14465-14483V14465c0-7972-6485-14465-14465-14465z"
          className="fil0"
        />
        <path
          d="M140260 99924h7031v-4044h-7031zM140260 113740h7031v-4044h-7031zM140260 127553h7031v-4044h-7031z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
